import { KATAKANA_ONLY } from "../../../constants/validationUtils";

// 役割ラベル
export const COMPANY_USER_ROLE_LABEL = {
  admin: "代表者",
  general: "担当者",
};

// 担当者の最大数
export const MAX_COMPANY_USERS = 5;

// 一覧部分のカラム幅
export const TABLE_COLUMNS =
  "minmax(0, 1.5fr) minmax(0, 1.5fr) minmax(0, 1.4fr) minmax(0, 1fr)";

// 氏名表示用
export const buildFullName = (lastName = "", firstName = "") =>
  `${lastName} ${firstName}`.trim() || "-";

const normalizeEmail = (email = "") => email.trim().toLowerCase();

// 余分な空白を削除
const trimValue = (value = "") => value.trim();

const buildUserValidationError = (user) => {
  const userErrors = {};
  const email = trimValue(user.email);
  const lastName = trimValue(user.last_name);
  const firstName = trimValue(user.first_name);
  const lastNameKana = user.last_name_kana ?? "";
  const firstNameKana = user.first_name_kana ?? "";

  if (!lastName) {
    userErrors.last_name = "姓は入力必須です。";
  }

  if (!firstName) {
    userErrors.first_name = "名は入力必須です。";
  }

  if (!trimValue(lastNameKana)) {
    userErrors.last_name_kana = "セイは入力必須です。";
  } else if (!KATAKANA_ONLY.test(lastNameKana)) {
    userErrors.last_name_kana = "セイは全角カタカナで入力してください。";
  }

  if (!trimValue(firstNameKana)) {
    userErrors.first_name_kana = "メイは入力必須です。";
  } else if (!KATAKANA_ONLY.test(firstNameKana)) {
    userErrors.first_name_kana = "メイは全角カタカナで入力してください。";
  }

  if (!email) {
    userErrors.email = "メールアドレスは入力必須です。";
  }

  return userErrors;
};

// 編集用の初期データを作る
// 削除は保存時にまとめて反映したいため _destroy を持たせる
export const buildInitialCompanyUsers = (company) =>
  (company.company_users || []).map((companyUser) => ({
    id: companyUser.id,
    role: companyUser.role || "general",
    email: companyUser.email || "",
    last_name: companyUser.last_name || "",
    first_name: companyUser.first_name || "",
    last_name_kana: companyUser.last_name_kana || "",
    first_name_kana: companyUser.first_name_kana || "",
    _destroy: false,
  }));

// 保存前バリデーション
export const validateCompanyUsers = (companyUsers) => {
  const errors = {
    users: {},
    role: null,
    base: null,
  };

  const activeUsers = companyUsers.filter((user) => !user._destroy);

  // 個別入力チェック
  activeUsers.forEach((user) => {
    const userErrors = buildUserValidationError(user);

    if (Object.keys(userErrors).length > 0) {
      errors.users[user.id] = userErrors;
    }
  });

  // payload 内メール重複チェック
  const emailMap = {};

  activeUsers.forEach((user) => {
    const email = trimValue(user.email);
    if (!email) return;

    const normalizedEmail = normalizeEmail(email);

    if (!emailMap[normalizedEmail]) {
      emailMap[normalizedEmail] = [];
    }

    emailMap[normalizedEmail].push(user);
  });

  Object.values(emailMap).forEach((users) => {
    if (users.length < 2) return;

    users.forEach((user) => {
      errors.users[user.id] = {
        ...(errors.users[user.id] || {}),
        email: "メールアドレスが重複しています。",
      };
    });
  });

  // 代表者チェック
  const adminCount = activeUsers.filter((user) => user.role === "admin").length;

  // 代表者は会社全体ルールなので個別ユーザーエラーではなく全体エラーとして扱う
  if (adminCount !== 1) {
    errors.base = "代表者は必ず1名選択してください。";
    errors.role = "代表者は必ず1名選択してください。";
  }

  return errors;
};
